import { defineComponent as _defineComponent } from 'vue'
import Input from '@/components/Input.vue'
import { ref } from 'vue'
import Typography from '@/components/Rain/Typography/Typography.vue'

interface Props {
    onBack: Function
    onSubmit: Function
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MFAVerifyRecoveryCode',
  emits: ['onBack', 'onSubmit'],
  setup(__props, { emit }) {


const recoveryCode = ref('')

const sendRecoveryCode = () => {
    emit('onSubmit', recoveryCode.value)
}

return { __sfc: true,emit, recoveryCode, sendRecoveryCode, Input, Typography }
}

})